import { render, staticRenderFns } from "./text_field.vue?vue&type=template&id=6dcb3fc6&scoped=true"
import script from "./text_field.vue?vue&type=script&lang=js"
export * from "./text_field.vue?vue&type=script&lang=js"
import style0 from "./text_field.vue?vue&type=style&index=0&id=6dcb3fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb3fc6",
  null
  
)

export default component.exports